module.exports = __webpack_public_path__ + "6767879b1a2b692fd5006d86005c67cf.MP3";